// extracted by mini-css-extract-plugin
export default {"iconBtn":"LastErrorInspectTrigger_iconBtn__1VjHW","mark":"LastErrorInspectTrigger_mark__7CPQA","letter":"LastErrorInspectTrigger_letter__ODFIn"};